// extracted by mini-css-extract-plugin
module.exports = {"map":"world-map_map__8eBv1","mapWrapper":"world-map_mapWrapper__1BHRJ"};